export default "__VITE_ASSET__DPcj$CaP__"